import React from "react";

export default function Dashboard2() {
  return (
    <div className="flex flex-col w-full px-10 gap-2 items-center justify-center pb-4">
      <div className="text-4xl font-medium">Dashboard</div>
      <div className="text-sm text-center text-balance">
        Perencanaan menu agar dapur dapat menjaga konsistensi dan efisiensi
        dalam penyediaan makanan, serta meminimalisir potensi kekurangan atau
        kelebihan bahan
      </div>
    </div>
  );
}
